import { Component, input } from '@angular/core';

@Component({
  selector: 'gs-loader',
  templateUrl: './gs-loader.component.html',
  styleUrls: ['./gs-loader.component.css'],
})
export class GsLoaderComponent {
  readonly mode = input<'blocking' | 'contained'>('blocking');
  readonly label = input('Loading');
}
